import api from '@/configs/GlobalRequestHandler.js';

export default {
  createAwardedQuote:(awardedQuoteBody, raffleId) => {
    return api.postRequestWithBody(`/campaigns_awarded_quotas/${raffleId}`, awardedQuoteBody)
  },
  deleteAwardedQuote:(awardedQuoteId) => {
    return api.deleteRequest(`/campaigns_awarded_quotas/${awardedQuoteId}`)
  },
}